import $store from '~/services/StoreService';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export default function nonCorporate(_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
  const store = $store();
  const user = store.getters['root/userService'];

  if (user.isCorporate) {
    window.location.href = '/admin';
    return;
  }
  next();
}
